import logo from './logo.svg';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './App.css';
import Index from './pages/index.js';
import About from './pages/about.js';
import Service from './pages/service.js';
import Contact from './pages/contact.js';
import Price from './pages/price.js';

import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

function ScrollAndPluginHandler() {
  const location = useLocation();

  useEffect(() => {
    // Delay to make sure React finished rendering the new page content
    const timer = setTimeout(() => {
      if (typeof window.initPlugins === 'function') {
        window.initPlugins();
      }

      // Optional: scroll to top on route change
      window.scrollTo(0, 0);
    }, 100); // You can tweak this delay

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
}

function App() {
  return ( 
    <div className="App">
      <Router>
        <ScrollAndPluginHandler />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<Service />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/price" element={<Price />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;

